'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.COLORS = void 0;
(function (COLORS) {
    COLORS["BLACK_300"] = "#161117";
    COLORS["BLACK_200"] = "#1D1922";
    COLORS["BLACK_100"] = "#22222d";
    COLORS["BLACK_50"] = "#3C3D47";
    COLORS["WHITE"] = "#FFFFFF";
    COLORS["ROSE_500"] = "#F46565";
    COLORS["ROSE_10"] = "#FFF4F4";
    COLORS["RED_400"] = "#E83938";
    COLORS["RED_500"] = "#D43737";
    COLORS["RED_600"] = "#C73434";
    COLORS["DARK_BLUE"] = "#150050";
    COLORS["ROYAL_BLUE"] = "#4967E5";
    COLORS["DARK_OCEAN_300"] = "#0E419A";
    COLORS["DARK_OCEAN_200"] = "#1255C9";
    COLORS["DARK_OCEAN_100"] = "#236CEB";
    COLORS["DARK_OCEAN"] = "4D81DC";
    COLORS["OCEAN_500"] = "#528BEF";
    COLORS["OCEAN_300"] = "#6DA5FF";
    COLORS["OCEAN_200"] = "#80B3FF";
    COLORS["OCEAN_100"] = "#96C2FF";
    COLORS["OCEAN_50"] = "#B0D2FF";
    COLORS["OCEAN_20"] = "#CDE4FF";
    COLORS["OCEAN_10"] = "#F2F8FF";
    COLORS["GREY_700"] = "#3F4042";
    COLORS["GREY_600"] = "#5E5F62";
    COLORS["GREY_500"] = "#70747D";
    COLORS["GREY_400"] = "#9D9FA4";
    COLORS["GREY_300"] = "#BCBFC5";
    COLORS["GREY_200"] = "#D1D4DB";
    COLORS["GREY_100"] = "#EEEFF2";
    COLORS["GREY_50"] = "#F5F5F7";
    COLORS["GREY_20"] = "#FBFBFC";
    COLORS["DARK_PAPAYA_100"] = "#BF5800";
    COLORS["PAPAYA_500"] = "#E27815";
    COLORS["PAPAYA_10"] = "#FFF8F2";
    COLORS["DARK_GREEN_100"] = "#227E18";
    COLORS["GREEN_500"] = "#2EA920";
    COLORS["GREEN_20"] = "#CCFCCC";
    COLORS["MANGO_500"] = "#F0BC3F";
    COLORS["MANGO_300"] = "#FFD75D";
    COLORS["MANGO_20"] = "#FFF9CC";
    COLORS["LILAC_50"] = "#D8D6FF";
    COLORS["LILAC_500"] = "#7B77FF";
    COLORS["BONE_WHITE"] = "#FFF6E8";
})(exports.COLORS || (exports.COLORS = {}));
var light_theme = {
    name: 'Light Theme',
    fonts: {
        primary: 'TT Commons',
    },
    shadows: {
        0: 'none',
        1: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
        2: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 3px rgba(0, 0, 0, 0.16)',
        3: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16)',
        4: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.16)',
        5: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.16)',
        6: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.16)',
        7: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 12px 14px rgba(0, 0, 0, 0.16)',
        8: '0px 6px 18px rgba(0, 0, 0, 0.12), 0px 14px 20px rgba(0, 0, 0, 0.16)',
        9: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
    },
    colors: {
        brand: {
            primary: exports.COLORS.ROSE_500,
            secondary: exports.COLORS.BLACK_50,
            background: exports.COLORS.WHITE,
        },
        button: {
            action: exports.COLORS.RED_500,
            action_hover: exports.COLORS.RED_600,
            interactive: exports.COLORS.OCEAN_500,
            interactive_hover: exports.COLORS.DARK_OCEAN,
            neutral: exports.COLORS.WHITE,
            disabled: exports.COLORS.GREY_300,
        },
        text: {
            primary: exports.COLORS.BLACK_100,
            secondary: exports.COLORS.GREY_500,
            disabled: exports.COLORS.GREY_400,
            negative: exports.COLORS.RED_500,
            warning: exports.COLORS.DARK_PAPAYA_100,
            positive: exports.COLORS.DARK_GREEN_100,
            interactive: exports.COLORS.DARK_OCEAN_100,
            interactive_hover: exports.COLORS.DARK_OCEAN_200,
            light: exports.COLORS.WHITE,
        },
        icon: {
            primary: exports.COLORS.BLACK_100,
            secondary: exports.COLORS.GREY_500,
            disabled: exports.COLORS.GREY_400,
            negative: exports.COLORS.RED_500,
            warning: exports.COLORS.PAPAYA_500,
            positive: exports.COLORS.DARK_GREEN_100,
            interactive: exports.COLORS.OCEAN_500,
            light: exports.COLORS.WHITE,
        },
        background: {
            primary: exports.COLORS.WHITE,
            secondary: exports.COLORS.GREY_50,
            tertiary: exports.COLORS.GREY_100,
            divider: exports.COLORS.GREY_200,
            stroke: exports.COLORS.GREY_400,
            quaternary: exports.COLORS.OCEAN_20,
            dark: exports.COLORS.BLACK_100,
            dropdown: exports.COLORS.WHITE,
        },
        border: {
            primary: exports.COLORS.GREY_100,
            opaque: exports.COLORS.GREY_200,
            selected: exports.COLORS.GREY_200,
        },
        input: {
            primary: exports.COLORS.GREY_200,
            secondary: exports.COLORS.GREY_500,
            interactive: exports.COLORS.OCEAN_500,
            negative: exports.COLORS.RED_500,
        },
    },
    typography: {
        display_1: {
            font_size: '64px',
            line_height: '70px',
            font_weight: 700,
            letter_spacing: '-1.5px',
        },
        display_2: {
            font_size: '48px',
            line_height: '54px',
            font_weight: 600,
            letter_spacing: '-1.5px',
        },
        quote: {
            font_size: '36px',
            line_height: '40px',
            font_weight: 400,
            letter_spacing: '-1.5px',
        },
        headline_1: {
            font_size: '36px',
            line_height: '48px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        headline_2: {
            font_size: '26px',
            line_height: '32px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        headline_3: {
            font_size: '22px',
            line_height: '28px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        title_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 600,
            letter_spacing: 'normal',
        },
        subtitle_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 500,
            letter_spacing: 'normal',
        },
        body_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 400,
            letter_spacing: 'normal',
        },
        title_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 600,
            letter_spacing: 'normal',
        },
        subtitle_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 500,
            letter_spacing: 'normal',
        },
        body_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 400,
            letter_spacing: 'normal',
        },
        button_text: {
            font_size: '16px',
            line_height: '22px',
            font_weight: 700,
            letter_spacing: '0.25px',
        },
        overline: {
            font_size: '12px',
            line_height: '18px',
            font_weight: 600,
            letter_spacing: '1px',
        },
        caption: {
            font_size: '13px',
            line_height: '18px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
    },
};
var dark_theme = {
    name: 'Dark Theme',
    fonts: {
        primary: 'TT Commons',
    },
    shadows: {
        0: 'none',
        1: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
        2: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 3px rgba(0, 0, 0, 0.16)',
        3: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16)',
        4: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 3px 6px rgba(0, 0, 0, 0.16)',
        5: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.16)',
        6: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.16)',
        7: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 12px 14px rgba(0, 0, 0, 0.16)',
        8: '0px 6px 18px rgba(0, 0, 0, 0.12), 0px 14px 20px rgba(0, 0, 0, 0.16)',
        9: '0px 0px 1px rgba(0, 0, 0, 0.12), 0px 1px 1px 1px rgba(0, 0, 0, 0.08)',
    },
    colors: {
        brand: {
            primary: exports.COLORS.DARK_BLUE,
            secondary: exports.COLORS.BONE_WHITE,
            background: exports.COLORS.ROYAL_BLUE,
        },
        button: {
            action: exports.COLORS.ROYAL_BLUE,
            action_hover: exports.COLORS.ROYAL_BLUE,
            interactive: exports.COLORS.OCEAN_500,
            interactive_hover: exports.COLORS.DARK_OCEAN,
            neutral: exports.COLORS.GREY_500,
            disabled: exports.COLORS.GREY_300,
        },
        text: {
            primary: exports.COLORS.WHITE,
            secondary: exports.COLORS.GREY_500,
            disabled: exports.COLORS.GREY_400,
            negative: exports.COLORS.RED_500,
            warning: exports.COLORS.DARK_PAPAYA_100,
            positive: exports.COLORS.DARK_GREEN_100,
            interactive: exports.COLORS.DARK_OCEAN_100,
            interactive_hover: exports.COLORS.DARK_OCEAN_200,
            light: exports.COLORS.WHITE,
        },
        icon: {
            primary: exports.COLORS.WHITE,
            secondary: exports.COLORS.GREY_500,
            disabled: exports.COLORS.GREY_400,
            negative: exports.COLORS.RED_500,
            warning: exports.COLORS.PAPAYA_500,
            positive: exports.COLORS.DARK_GREEN_100,
            interactive: exports.COLORS.OCEAN_500,
            light: exports.COLORS.WHITE,
        },
        background: {
            primary: exports.COLORS.DARK_BLUE,
            secondary: exports.COLORS.GREY_500,
            tertiary: exports.COLORS.ROYAL_BLUE,
            divider: exports.COLORS.GREY_200,
            stroke: exports.COLORS.GREY_400,
            quaternary: exports.COLORS.OCEAN_20,
            dark: exports.COLORS.BLACK_100,
            dropdown: exports.COLORS.GREY_400,
        },
        border: {
            primary: exports.COLORS.GREY_500,
            opaque: exports.COLORS.WHITE,
            selected: exports.COLORS.GREY_200,
        },
        input: {
            primary: exports.COLORS.GREY_500,
            secondary: exports.COLORS.WHITE,
            interactive: exports.COLORS.OCEAN_500,
            negative: exports.COLORS.RED_500,
        },
    },
    typography: {
        display_1: {
            font_size: '64px',
            line_height: '70px',
            font_weight: 700,
            letter_spacing: '-1.5px',
        },
        display_2: {
            font_size: '48px',
            line_height: '54px',
            font_weight: 600,
            letter_spacing: '-1.5px',
        },
        quote: {
            font_size: '36px',
            line_height: '40px',
            font_weight: 400,
            letter_spacing: '-1.5px',
        },
        headline_1: {
            font_size: '36px',
            line_height: '48px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        headline_2: {
            font_size: '26px',
            line_height: '32px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        headline_3: {
            font_size: '22px',
            line_height: '28px',
            font_weight: 700,
            letter_spacing: '0px',
        },
        title_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 600,
            letter_spacing: 'normal',
        },
        subtitle_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 500,
            letter_spacing: 'normal',
        },
        body_1: {
            font_size: '20px',
            line_height: '24px',
            font_weight: 400,
            letter_spacing: 'normal',
        },
        title_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 600,
            letter_spacing: 'normal',
        },
        subtitle_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 500,
            letter_spacing: 'normal',
        },
        body_2: {
            font_size: '16px',
            line_height: '24px',
            font_weight: 400,
            letter_spacing: 'normal',
        },
        button_text: {
            font_size: '16px',
            line_height: '22px',
            font_weight: 700,
            letter_spacing: '0.25px',
        },
        overline: {
            font_size: '12px',
            line_height: '18px',
            font_weight: 600,
            letter_spacing: '1px',
        },
        caption: {
            font_size: '13px',
            line_height: '18px',
            font_weight: 400,
            letter_spacing: '0.25px',
        },
    },
};

exports.dark_theme = dark_theme;
exports.light_theme = light_theme;
